import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=32b78a38&scoped=true&"
import script from "./tickets.vue?vue&type=script&lang=js&"
export * from "./tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b78a38",
  null
  
)

export default component.exports